import { render } from "./ModalPrintWitness.vue?vue&type=template&id=3ef92640"
import script from "./ModalPrintWitness.vue?vue&type=script&lang=js"
export * from "./ModalPrintWitness.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__